/* eslint-disable */

import React from 'react';

export default function WireframeFooterDesktop() {
    return (
        <>
            <style
                jsx
                global
            >{`
                #c24-page-container-header,
                #c24-page-container-footer {
                    -webkit-flex: none;
                    -ms-flex: none;
                    flex: none;
                }

                #c24-header a:focus-visible,
                #c24-header span:focus-visible,
                #c24-footer a:focus-visible,
                #c24-footer span:focus-visible {
                    outline: none;
                    box-shadow: 0 0 0 1px #fff;
                }

                .c24-logo,
                .c24-cc-logo,
                .c24-footer-logo {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-repeat: no-repeat;
                }

                .c24-footer,
                .c24-footer * {
                    -webkit-text-size-adjust: none !important;
                    box-sizing: border-box;
                }

                .c24-footer {
                    display: block;
                    width: 100%;
                    position: relative;
                }

                .c24-footer-top {
                    font-size: 14px;
                    line-height: 18px;
                }

                .c24-footer-jumptotop {
                    width: 100%;
                    text-align: center;
                    line-height: 50px;
                    font-size: 14px;
                    color: #fff;
                    background: #0563c1;
                    cursor: pointer;
                }

                .c24-footer-jumptotop:hover {
                    text-decoration: underline;
                }

                .c24-footer-links-wrapper {
                    background: #022d94;
                }

                .c24-footer-links-separator {
                    border-bottom: 1px solid #dcdcdc;
                    margin: 0 20px;
                }

                .c24-footer-links,
                .c24-footer-bottom-links {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    padding: 30px 0;
                }

                .c24-footer-bottom-links {
                    padding: 24px 0 16px;
                }

                .c24-footer-links ul,
                .c24-footer-bottom-links ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                .c24-footer-links ul {
                    margin-right: 39px;
                }

                .c24-footer-links .c24-footer-link-first-ele {
                    margin-right: 100px;
                    color: #ffffff;
                }

                .c24-footer-links-wrapper .c24-footer-link-first-ele .c24-footer-logo-wrapper {
                    padding-top: 0;
                }

                .c24-footer-links-wrapper .c24-footer-link-first-ele .c24-footer-logo {
                    width: 155px;
                    height: 38px;
                    margin: unset;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-terms-links {
                    display: unset;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-terms-links a {
                    margin-right: 5px;
                    margin-left: 5px;
                    color: #ffffff;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-terms-links a:first-child {
                    margin-left: 0;
                    font-weight: normal;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-logo-subline {
                    white-space: nowrap;
                    margin-top: 5px;
                    margin-bottom: 24px;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon-wrapper {
                    margin-top: 16px;
                    display: flex;
                    gap: 16px;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon {
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    overflow: hidden;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon:hover {
                    text-decoration: none;
                    color: unset;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon div {
                    background-repeat: no-repeat;
                    width: 32px;
                    height: 32px;
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-facebook-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxwYXRoIGQ9Ik0yNC42MzksMTYuNDRsLS4yNTIsMy4yMzZoLTMuMzQ0djEwLjc4OGgtMy45NTV2LTEwLjc4OGgtMi4xNTh2LTMuMjM2aDIuMTU4di0yLjA1YzAtLjkzNSwwLTIuMzczLjY4My0zLjI3Mi43MTktLjkzNSwxLjY5LTEuNTgyLDMuMzgtMS41ODIsMi43NjksMCwzLjkyLjM5NiwzLjkyLjM5NmwtLjUzOSwzLjIzNnMtLjk3MS0uMjUyLTEuNzk4LS4yNTJjLS44NjMsMC0xLjY1NC4zMjQtMS42NTQsMS4xNTF2Mi4zNzNzMy41NiwwLDMuNTYsMFoiIGZpbGw9IiM5OTkiIHN0cm9rZS13aWR0aD0iMCIvPjwvc3ZnPg==');
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-youtube-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxwYXRoIGQ9Ik0yOS44MiwxNS4wNjZjLS4yMzYtLjg4Mi0uOTMtMS41NzYtMS44MTItMS44MTItMS41OTktLjQyOC04LjAwOC0uNDI4LTguMDA4LS40MjgsMCwwLTYuNDA5LDAtOC4wMDguNDI4LS44ODIuMjM2LTEuNTc2LjkzLTEuODEyLDEuODEyLS40MjgsMS41OTktLjQyOCw0LjkzNC0uNDI4LDQuOTM0LDAsMCwwLDMuMzM1LjQyOCw0LjkzNC4yMzYuODgyLjkzLDEuNTc2LDEuODEyLDEuODEyLDEuNTk5LjQyOCw4LjAwOC40MjgsOC4wMDguNDI4LDAsMCw2LjQwOSwwLDguMDA4LS40MjguODgyLS4yMzYsMS41NzYtLjkzLDEuODEyLTEuODEyLjQyOC0xLjU5OS40MjgtNC45MzQuNDI4LTQuOTM0LDAsMCwwLTMuMzM1LS40MjgtNC45MzRaTTE4LjA1NywyMy4wNzR2LTYuMTQ5bDUuMzI1LDMuMDc0LTUuMzI1LDMuMDc0WiIgZmlsbD0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIwIi8+PC9zdmc+');
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-instagram-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjQuNjM0IiBmaWxsPSIjOTk5IiBzdHJva2Utd2lkdGg9IjAiLz48cGF0aCBkPSJNMjUuNzIzLDExLjE3OGgtMTEuNDQ2Yy0xLjcxMSwwLTMuMDk5LDEuMzg3LTMuMDk5LDMuMDk5djExLjQ0NmMwLDEuNzExLDEuMzg3LDMuMDk5LDMuMDk5LDMuMDk5aDExLjQ0NmMxLjcxMiwwLDMuMDk5LTEuMzg3LDMuMDk5LTMuMDk5di0xMS40NDZjMC0xLjcxMS0xLjM4OC0zLjA5OS0zLjA5OS0zLjA5OVpNMjAsMjYuMDM2Yy0zLjMzMywwLTYuMDM2LTIuNzAyLTYuMDM2LTYuMDM2czIuNzAyLTYuMDM2LDYuMDM2LTYuMDM2LDYuMDM2LDIuNzAyLDYuMDM2LDYuMDM2LTIuNzAzLDYuMDM2LTYuMDM2LDYuMDM2Wk0yNi4yMTEsMTQuNDU0Yy0uNjA0LDAtMS4wOTQtLjQ5LTEuMDk0LTEuMDk0cy40OS0xLjA5NCwxLjA5NC0xLjA5NCwxLjA5NC40OSwxLjA5NCwxLjA5NC0uNDksMS4wOTQtMS4wOTQsMS4wOTRaIiBmaWxsPSIjOTk5IiBzdHJva2Utd2lkdGg9IjAiLz48L3N2Zz4=');
                }

                .c24-footer-links .c24-footer-link-first-ele .c24-footer-icon .c24-tiktok-logo {
                    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJFYmVuZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iNCIgcnk9IjQiIGZpbGw9IiNmZmYiIHN0cm9rZS13aWR0aD0iMCIvPjxwYXRoIGQ9Ik0yMC40NDIsOS45MTNjMS4xMDMtLjAxNywyLjE5OC0uMDA4LDMuMjkyLS4wMTcuMDY3LDEuMjg4LjUzLDIuNjAyLDEuNDczLDMuNTExLjk0My45MzUsMi4yNzMsMS4zNjQsMy41NywxLjUwN3YzLjM5M2MtMS4yMTItLjA0Mi0yLjQzMy0uMjk1LTMuNTM2LS44MTctLjQ4LS4yMTktLjkyNi0uNDk3LTEuMzY0LS43ODMtLjAwOCwyLjQ1OS4wMDgsNC45MTctLjAxNyw3LjM2Ny0uMDY3LDEuMTc5LS40NTUsMi4zNDktMS4xMzcsMy4zMTctMS4xMDMsMS42MTctMy4wMTQsMi42NjktNC45NzYsMi43MDMtMS4yMDQuMDY3LTIuNDA4LS4yNjEtMy40MzUtLjg2Ny0xLjcwMS0xLjAwMi0yLjg5Ni0yLjgzNy0zLjA3My00LjgwOC0uMDE3LS40MjEtLjAyNS0uODQyLS4wMDgtMS4yNTUuMTUyLTEuNi45NDMtMy4xMzIsMi4xNzItNC4xNzYsMS4zOTgtMS4yMTIsMy4zNTEtMS43OTMsNS4xNzgtMS40NDguMDE3LDEuMjQ2LS4wMzQsMi40OTItLjAzNCwzLjczOC0uODM0LS4yNjktMS44MS0uMTk0LTIuNTQzLjMxMi0uNTMuMzQ1LS45MzUuODc2LTEuMTQ1LDEuNDczLS4xNzcuNDI5LS4xMjYuOTAxLS4xMTgsMS4zNTYuMjAyLDEuMzgxLDEuNTMyLDIuNTQzLDIuOTQ3LDIuNDE2Ljk0My0uMDA4LDEuODQ0LS41NTYsMi4zMzItMS4zNTYuMTYtLjI3OC4zMzctLjU2NC4zNDUtLjg5My4wODQtMS41MDcuMDUxLTMuMDA2LjA1OS00LjUxMy4wMDgtMy4zOTMtLjAwOC02Ljc3OC4wMTctMTAuMTYzaDBaIiBmaWxsPSIjOTk5IiBzdHJva2Utd2lkdGg9IjAiLz48L3N2Zz4=');
                }

                .c24-footer-links ul:last-child {
                    margin-right: 0;
                }

                .c24-footer-bottom-links ul {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    flex-wrap: wrap;
                    -webkit-flex-wrap: wrap;
                    white-space: nowrap;
                }

                .c24-footer-links ul li,
                .c24-footer-links ul li a,
                .c24-footer-links ul li a:hover,
                .c24-footer-bottom-links ul li,
                .c24-footer-bottom-links ul li a,
                .c24-footer-bottom-links ul li a:hover {
                    color: #fff;
                }

                .c24-footer-links ul li {
                    margin-top: 10px;
                }

                .c24-footer-links ul li:first-child {
                    font-weight: bold;
                    margin-top: 0;
                }

                .c24-footer-bottom-links ul li {
                    margin: 0 15px;
                }

                .c24-footer-slim-item {
                    display: none;
                }

                .c24-footer-bottom {
                    width: 100%;
                    background: #022d94;
                    color: #fff;
                    font-size: 12px;
                    line-height: 16px;
                }

                .c24-footer-logo-wrapper {
                    padding-top: 27px;
                }

                .c24-footer-logo {
                    display: block;
                    width: 89px;
                    height: 22px;
                    margin: 0 auto;
                }

                .c24-footer-copyright {
                    text-align: center;
                    padding: 0 15px 16px 15px;
                }

                .c24-footer:not(.c24-footer-slim) .c24-footer-copyright {
                    padding: 32px 15px;
                    font-size: 14px;
                }

                .c24-footer:not(.c24-footer-slim) .c24-footer-bottom-links {
                    display: none;
                }

                .c24-footer:not(.c24-footer-slim) .c24-footer-links {
                    padding: 30px 20px;
                }

                .c24-footer-slim .c24-footer-top,
                .c24-footer-slim .c24-footer-logo-wrapper {
                    display: none;
                }

                .c24-footer-slim .c24-footer-bottom {
                    background: #fff;
                    color: #333333;
                    padding-top: 16px;
                }

                .c24-footer-slim .c24-footer-bottom-links {
                    padding-top: 0;
                }

                .c24-footer-slim .c24-footer-bottom-links ul li a,
                .c24-footer-slim .c24-footer-bottom-links ul li a:hover {
                    color: #333333;
                }

                .c24-footer-slim .c24-footer-slim-item {
                    display: block;
                }

                @media (max-width: 1155px) {
                    .c24-footer-links .c24-footer-link-first-ele {
                        margin-right: 40px;
                    }
                }
                @media print {
                    #c24-header-nav,
                    #c24-header-search,
                    #c24-header-tv,
                    #c24-breadcrumb,
                    #c24-footer-container,
                    #c24-ad-banner,
                    #c24-ad-skyscraper,
                    svg {
                        display: none;
                    }
                }
                .c24-nav-blocking-layer-footer {
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0);
                    z-index: 900;
                    display: none;
                }

                *.hidden {
                    display: none !important;
                }
                .body--app .c24m-desktop-link {
                    display: none;
                }

                .c24-footer-copyright {
                    display: flex;
                    gap: 5px;
                    justify-content: center;
                }
            `}</style>
            <footer
                className={`c24-footer `}
                data-nosnippet="true"
            >
                <div id="c24-footer">
                    <div className={`c24-footer-top`}>
                        <div className={`c24-footer-content clearfix`}>
                            <div className={`c24-footer-jumptotop`}>zur&uuml;ck zum Seitenanfang</div>
                            <div className={`c24-footer-links-wrapper`}>
                                <div className={`c24-footer-links`}>
                                    <div className={`c24-footer-link-first-ele`}>
                                        <div className={`c24-footer-logo-wrapper`}>
                                            <a
                                                className={`c24-footer-logo`}
                                                href={`https://www.check24.de/`}
                                                title="CHECK24 - Deutschlands gr&ouml;&szlig;tes Vergleichsportal"
                                            ></a>
                                        </div>
                                        <div className={`c24-footer-logo-subline`}>
                                            Deutschlands größtes Vergleichsportal
                                        </div>
                                        <div className={`c24-footer-terms-links`}>
                                            <a
                                                href={`https://individualreisen.check24.de/dateien/agb.pdf`}
                                                title="AGB"
                                            >
                                                AGB
                                            </a>{' '}
                                            |
                                            <a
                                                href={`https://individualreisen.check24.de/dateien/datenschutzhinweise.pdf?v=4`}
                                                title="Datenschutz"
                                            >
                                                Datenschutz
                                            </a>{' '}
                                            |
                                            <a
                                                href={`https://www.check24.de/unternehmen/impressum/#comp50`}
                                                title="Impressum"
                                            >
                                                Impressum
                                            </a>
                                        </div>
                                        <div className={`c24-footer-icon-wrapper`}>
                                            <a
                                                className={`c24-footer-icon`}
                                                href={`//www.facebook.com/CHECK24de/?locale=de_DE`}
                                                aria-label="Social Link"
                                            >
                                                <div className={`c24-facebook-logo`}></div>
                                            </a>
                                            <a
                                                className={`c24-footer-icon`}
                                                href={`//www.youtube.com/@check24`}
                                                aria-label="Social Link"
                                            >
                                                <div className={`c24-youtube-logo`}></div>
                                            </a>
                                            <a
                                                className={`c24-footer-icon`}
                                                href={`//instagram.com/check24.de`}
                                                aria-label="Social Link"
                                            >
                                                <div className={`c24-instagram-logo`}></div>
                                            </a>
                                            <a
                                                className={`c24-footer-icon`}
                                                href={`//www.tiktok.com/@check24`}
                                                aria-label="Social Link"
                                            >
                                                <div className={`c24-tiktok-logo`}></div>
                                            </a>
                                        </div>
                                    </div>
                                    <ul>
                                        <li>&Uuml;ber CHECK24</li>
                                        <li>
                                            <a
                                                href={`https://jobs.check24.de/de/`}
                                                title="Karriere"
                                            >
                                                Karriere
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/unternehmen/presse/`}
                                                title="Presse"
                                            >
                                                Presse
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/unternehmen/`}
                                                title="Unternehmen"
                                            >
                                                Unternehmen
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.at/`}
                                                title="CHECK24 &Ouml;sterreich"
                                            >
                                                CHECK24 &Ouml;sterreich
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.es/`}
                                                title="CHECK24 Spanien"
                                            >
                                                CHECK24 Spanien
                                            </a>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>Unsere Partner</li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/partner/`}
                                                title="Partnerprogramm"
                                            >
                                                Partnerprogramm
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://experts.profis.check24.de/portal/cs/unternehmen/`}
                                                title="Profi werden"
                                            >
                                                Profi werden
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/partner/partnerprogramm/`}
                                                title="Affiliate werden"
                                            >
                                                Affiliate werden
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://extranet.hotel.check24.de/register?_locale=de`}
                                                title="Unterkunft anmelden"
                                            >
                                                Unterkunft anmelden
                                            </a>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>Unser Engagement</li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/unternehmen/nachhaltigkeit/`}
                                                title="Nachhaltigkeit"
                                            >
                                                Nachhaltigkeit
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24-hilft.org/category/kinder`}
                                                title="CHECK24 hilft Kindern"
                                            >
                                                CHECK24 <i>hilft</i> Kindern
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24-hilft.org/category/umwelt`}
                                                title="CHECK24 hilft der Natur"
                                            >
                                                CHECK24 <i>hilft</i> der Natur
                                            </a>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>Unser Service für Sie</li>
                                        <li>
                                            <a
                                                className={`c24-footer-link-contact`}
                                                href={`https://www.check24.de/unternehmen/kontakt/`}
                                                title="Hilfe und Kontakt"
                                            >
                                                Hilfe und Kontakt
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/app/`}
                                                title="CHECK24 App"
                                            >
                                                CHECK24 App
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.check24.de/gutschein/`}
                                                title="CHECK24 Gutscheine"
                                            >
                                                CHECK24 Gutscheine
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://kundenbereich.check24.de/user/points.html`}
                                                title="CHECK24 Punkte"
                                            >
                                                CHECK24 Punkte
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className={`c24-footer-links-separator`}></div>
                            </div>
                        </div>
                    </div>
                    <div className={`c24-footer-bottom`}>
                        <div className={`c24-footer-content clearfix`}>
                            <div className={`c24-footer-bottom-links`}>
                                <ul>
                                    <li className={`c24-footer-slim-item c24-footer-link-contact`}>
                                        <a
                                            href={`https://www.check24.de/unternehmen/kontakt/`}
                                            title="Kontakt"
                                        >
                                            Kontakt
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className={`c24-footer-link-conditions`}
                                            href={`https://individualreisen.check24.de/dateien/agb.pdf`}
                                            title="Unsere AGB"
                                        >
                                            Unsere AGB
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className={`c24-footer-link-privacy`}
                                            href={`https://individualreisen.check24.de/dateien/datenschutzhinweise.pdf?v=4`}
                                            title="Datenschutz"
                                        >
                                            Datenschutz
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className={`c24-footer-link-imprint`}
                                            href={`https://www.check24.de/unternehmen/impressum/#comp50`}
                                            title="Impressum"
                                        >
                                            Impressum
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className={`c24-footer-copyright`}>
                                <span>&copy; 2025 CHECK24 Vergleichsportal Individualreisen GmbH, Düsseldorf.</span>
                                <span>Alle Inhalte unterliegen unserem Copyright.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
